import BIForm from './form/form';

$(function () {
    if ($("section").hasClass("register-interest-banner")){
        let RegisterForm = new BIForm({
            form_id: '.register-interest-form'
        });

        RegisterForm.addSubmitListener(() => {
            $('.register-interest-form').fadeOut(function () {
                $('.register-interest-banner .success').removeClass('d-none');
            });
        });
    }
});